import { initCaseStudiesGalleryCarousel } from '../../snippets/pro-builder-case-studies-template-gallery/pro-builder-case-studies-template-gallery';
import YTPlayer from '../../scripts/components/YTPlayer';

window.onReady(() => {
  initCaseStudiesGalleryCarousel();
  YTPlayer.init();
});
